import { useLocalization } from "@fluent/react";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const TemplateStatusFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const label = l10n.getString(
    FILTER_CONFIG[FilterChips.TEMPLATE_STATUS].labelKey
  );

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.TEMPLATE_STATUS}
      filterOptions={FILTER_CONFIG[FilterChips.TEMPLATE_STATUS].options}
      label={label}
    />
  );
};

export default TemplateStatusFilter;
